// SEO utilities for legal pages
export interface SEOData {
  title: string;
  description: string;
  canonical: string;
  hreflang: Array<{ lang: string; url: string }>;
}

export function generateLegalPageSEO(
  page: 'privacy' | 'terms',
  locale: 'en' | 'ar',
  baseUrl: string = 'https://vitaloapp.com'
): SEOData {
  const paths = {
    privacy: {
      en: '/privacy-policy',
      ar: '/ar/privacy-policy'
    },
    terms: {
      en: '/terms',
      ar: '/ar/terms'
    }
  };

  const currentPath = paths[page][locale];

  return {
    title: '', // Will be filled by component
    description: '', // Will be filled by component
    canonical: `${baseUrl}${currentPath}`,
    hreflang: [
      { lang: 'en', url: `${baseUrl}${paths[page].en}` },
      { lang: 'ar', url: `${baseUrl}${paths[page].ar}` },
      { lang: 'x-default', url: `${baseUrl}${paths[page].en}` }
    ]
  };
}

export function formatLastUpdated(locale: 'en' | 'ar'): string {
  return locale === 'ar' ? '17 أغسطس 2026' : '17 August 2026';
}
